export default __webpack_public_path__ + "static/media/Wheels.9da184d7.png";